import { connect } from 'react-redux';

import { getSelectOptions } from 'src/reducers/selectOptions';
import CommutingByCarShow from '../components/CommutingByCarShow';

const mapStateToProps = state => ({
  commutingDistances: getSelectOptions(state, 'commutingDistances')
});

export default connect(mapStateToProps)(CommutingByCarShow);
